import config from 'src/config';
import engineApiSlice from 'src/shared/state/api-slices/engineApiSlice';
import { executeEngineQuery } from 'src/app/portfolio/state/api/engineQueryUtils';
import {
    getPortfolioNatureStatusQuery,
    type GetPortfolioNatureStatusResult,
    type SetNatureStatusResponse,
} from './portfolioNatureStatusQuery';

const portfolioNatureStatusSlice = engineApiSlice.injectEndpoints({
    endpoints: builder => ({
        getPortfolioNatureStatus: builder.query<GetPortfolioNatureStatusResult, { businessCentralId: string }>({
            queryFn: arg =>
                executeEngineQuery<GetPortfolioNatureStatusResult>(
                    `${config.engineApiUrl.replace(/\/$/, '')}/query`,
                    getPortfolioNatureStatusQuery,
                    { businessCentralId: arg.businessCentralId }
                ),
            providesTags: (_result, _error, arg) => [{ type: 'organisation' as const, id: arg.businessCentralId }],
        }),
        setPortfolioNatureStatus: builder.mutation<SetNatureStatusResponse, { businessCentralId: string; content: string }>({
            query: params => ({
                url: `/orgs/${params.businessCentralId}/nature-status`,
                method: 'POST',
                body: { content: params.content },
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                const patchResult = dispatch(
                    portfolioNatureStatusSlice.util.updateQueryData(
                        'getPortfolioNatureStatus',
                        { businessCentralId: arg.businessCentralId },
                        draft => {
                            if (draft.organisation?.natureStatus) {
                                draft.organisation.natureStatus.content = arg.content;
                            } else if (draft.organisation) {
                                draft.organisation.natureStatus = { content: arg.content, createdAt: '' };
                            }
                        }
                    )
                );
                try {
                    const { data } = await queryFulfilled;
                    dispatch(
                        portfolioNatureStatusSlice.util.updateQueryData(
                            'getPortfolioNatureStatus',
                            { businessCentralId: arg.businessCentralId },
                            draft => {
                                if (draft.organisation) {
                                    draft.organisation.natureStatus = { content: data.content, createdAt: data.createdAt };
                                }
                            }
                        )
                    );
                } catch {
                    patchResult.undo();
                }
            },
            invalidatesTags: (_result, _error, arg) => [{ type: 'organisation' as const, id: arg.businessCentralId }],
        }),
    }),
});

export const { useGetPortfolioNatureStatusQuery, useSetPortfolioNatureStatusMutation } = portfolioNatureStatusSlice;

export default portfolioNatureStatusSlice;
